import { Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogConfig,
} from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';
import { EventOrderList } from 'src/modules/event/components/order-list/component';
import { OrderApiService } from 'src/modules/order/services/order-api-service';
import { OrderDataSource } from 'src/modules/order/services/order-data-source';
import { LocationPicker } from '../../directives/location-picker/component';

import { ITicket } from '../../interfaces/ticket';
import { ITicketListConfig } from '../../interfaces/ticket-list-config';
import { ITicketLocation } from '../../interfaces/ticket-location';
import { TicketLocationDataSource } from '../../services/ticket-location-data-source';
import { TicketsEdit } from '../edit/component';
import moment from 'moment';

@Component({
    selector: 'ticket-list-dialog',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class TicketsList {
  public displayedColumns = [
    'date',
    'unreleasedTickets',
    'ticketsAvailable',
    'ticketsSold',
    'totalTickets',
    'price',
    'actions',
  ];
  protected DataSource: TicketLocationDataSource;
  public EventLocations: BehaviorSubject<ITicketLocation[]>;
  public loading: boolean = true;
  public listingId: string;
  public listingTitle: string;
  public selectedLocation: ITicketLocation;
  public filter: string;
  public Data: ITicketLocation[];
  public locations: ITicketLocation[];
  public companyId: number;
  constructor(
    @Inject(MAT_DIALOG_DATA) private data: ITicketListConfig,
    private dataSource: TicketLocationDataSource,
    protected OrderApi: OrderApiService,
    protected Dialog: MatDialog
  ) {
    this.listingId = this.data.listingId;
    this.listingTitle = this.data.listingTitle;
    this.DataSource = this.dataSource;
    this.companyId = this.data.companyId;
  }

  async ngOnInit() {
    this.loading = true;
    const results = (await this.DataSource.List(this.listingId)).data;
    this.Data = results.filter((item) => item.Tickets.length > 0);
    this.locations = results.filter((item) => item.Tickets.length <= 0);
    this.selectedLocation = this.Data[0];
    this.loading = false;
  }

  public setFilter(value) {
    this.filter = value;
  }

  protected setPanel(EventLocation?: ITicketLocation) {
    this.selectedLocation = EventLocation;
  }

  public getEventsWithTickets(array, location) {
    let data = array;

    if (this.filter === 'live') {
      data = data.map((event) => {
        const tickets = event.Tickets.filter((ticket) => {
          return ticket.flags.live === true && ticket.ticketsAvailable !== 0;
        });
        return { ...event, Tickets: tickets };
      });
    } else if (this.filter === 'sold') {
      data = data.map((event) => {
        const tickets = event.Tickets.filter((ticket) => {
          return ticket.ticketsAvailable === 0;
        });
        return { ...event, Tickets: tickets };
      });
    }

    return data.find(
      (row) => row.companyLocationId === location.companyLocationId
    ).Tickets;
  }

  public addLocation() {
    const config = new MatDialogConfig();

    config.data = {
      listingTitle: this.listingTitle,
      locations: this.locations,
      organisation: { id: this.companyId },
    };

    this.Dialog.open(LocationPicker, config)
      .afterClosed()
      .subscribe((location) => location && this.editItem(location));
  }

  public editItem(TicketLocation: ITicketLocation, Ticket?: ITicket) {
    const config = new MatDialogConfig();

    config.disableClose = true;
    config.data = {
      ProductId: this.listingId,
      EventTitle: this.listingTitle,
      EventLocation: TicketLocation,
      Ticket: Ticket
        ? Ticket
        : {
            prices: {
              adultPartner: {
                slug: 'adultPartner',
                label: 'Adult Partner',
              },
            },
            deliveryMethod: 'collection',
          },
    };

    this.Dialog.open(TicketsEdit, config)
      .afterClosed()
      .subscribe((updated) => updated && this.ngOnInit());
  }

  public copyItem(TicketLocation: ITicketLocation, Ticket: ITicket) {
    const newTicket = {
      ...Ticket,
      id: null,
      startDate: null,
      endDate: null,
      ticketsAvalible: Ticket.totalTickets,
      ticketsSold: 0,
    };

    this.editItem(TicketLocation, newTicket);
  }

  public deleteItem(TicketLocation: ITicketLocation, Ticket: ITicket) {
    confirm(`Are you sure you want to delete: ${this.listingTitle}`) &&
      this.DataSource.delete(this.listingId, Ticket.id).then(() =>
        this.ngOnInit()
      );
  }

  public listSold(row) {
    const config = new MatDialogConfig();
    config.disableClose = true;
    const DataSource = new OrderDataSource(this.OrderApi);

    const title = row.listingTitle;
    const Item = {
      ...row,
      event_title: row.listingTitle,
      location_title: row.listingLocation,
      start_date: row.startDate,
    };

    config.data = {
      title,
      Item,
      DataSource,
    };

    this.Dialog.open(EventOrderList, config)
      .afterClosed()
      .subscribe((ticketId) => !!ticketId);
  }

  public getDisplayPrice(row) {
    if (row.prices.adultPartner) {
      return row.prices.adultPartner.price;
    } else if (row.prices.partnerPrice) {
      return row.prices.partnerPrice.price;
    }
    return row.prices[Object.keys(row.prices)[0]].price;
  }

  public disableRow(row) {
    return (
      moment(row.releaseDate, 'DD/MM/YYYY') < moment() &&
      row.ticketsAvailable === 0
    );
  }
}
